import { useEffect, useRef, useState } from 'react';

import { ShareCollectionContentOverlay } from 'components/ShareCollectionContentOverlay';
import Draggable from 'components/Draggable';
import { Services } from '@src/services';
import { ServiceName } from '@src/types/Services';
import { IMediaService } from '@src/types/Media';
import { MediaView } from 'common';
import { ShareInfo } from '@src/types/share';
import { MediaType, RightRequestMQLStatus } from '@adalong/schemas';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';

interface IProps {
  onShare: (info: ShareInfo) => any
  media: MediaView
}

function OriginalUGC({ onShare, media }: IProps) {
  const [error, setError] = useState(false);
  const downloading = useRef(false);
  const mediaService = useRef<IMediaService>(
    Services.get<IMediaService>(ServiceName.MediaService),
  );

  useEffect(() => {
    fetch(media.cdn_image ?? '', { method: 'HEAD' })
      .then((e) => {
        if (e.status === 404) {
          setError(true);
        }
      })
      .catch(console.error);
  }, [media.cdn_image]);

  function handleShare() {
    onShare({
      image: media.cdn_image,
      file: media[media.type === 'video' ? 'cdn_video' : 'cdn_image'],
      fileType: media.type === MediaType.Image ? 'image' : 'video',
      _id: media._id,
      creator: media.source.user_name,
    });
  }

  function download() {
    if (downloading.current) {
      return;
    }
    downloading.current = true;
    mediaService.current.download(media).finally(() => {
      downloading.current = false;
    });
  }

  if (error) {
    return null;
  }

  return (
    <Draggable
      className="thumbnail"
      style={{ backgroundImage: `url("${media.cdn_thumbnail ?? ''}")` }}
      info={{
        origin: 'share',
        type: 'media',
        content: media,
      }}
      draggable={media.rightsRequestStatus === RightRequestMQLStatus.Agreed}
    >
      {media.type === 'video'
        ? (
          <div className="play-button">
            <PlayArrowRoundedIcon
              style={{ fontSize: '5rem', margin: 'auto' }}
            />
          </div>
        ) : null}
      <ShareCollectionContentOverlay
        haveRights={media.rightsRequestStatus === RightRequestMQLStatus.Agreed}
        isInstagramVideo={media.type === 'video' && media.source.name === 'instagram'}
        onShare={handleShare}
        onDownload={download}
      />
    </Draggable>
  );
}

export default OriginalUGC;
